import template from './pagination.html';
import controller from './pagination.controller';

const paginationComponent = {
  restrict: 'E',
  bindings: {
    onPageChange: '<',
    elementsCount: '<',
    pageSize: '<'
  },
  template,
  controller
};

export default paginationComponent;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/pagination/pagination.component.js
 **/